import getCapabilities from 'utils/capabilities'

/**
 * Whether Ask MDT is offered to this user at all (MYD-621).
 *
 * The same three answers the server gives, in the same order, so the UI never
 * shows a button that can only 404 or 403:
 *
 *   1. AI switched on for this deployment: `window.__MDT_CONFIG__.aiEnabled`,
 *      from /config.js (backend/utilities/runtimeConfig.js), which is absent
 *      entirely while AI is off
 *   2. the account may use AI: the `canUseAi` capability (pro), false while it
 *      is a trial or community account
 *   3. the deployment's `AI_ALLOWED_ACCOUNT_TYPES`, which can narrow a rollout
 *
 * The server is still the enforcer; this decides what to show.
 */

export interface AiRuntimeConfig {
	aiEnabled?: boolean
	aiAccountTypes?: readonly string[]
}

// Read without redeclaring `Window.__MDT_CONFIG__`: features/Chat declares it
// with only the field chat uses, and two global declarations must agree.
export const runtimeAiConfig = (): AiRuntimeConfig =>
	typeof window !== 'undefined' ? (((window as unknown as { __MDT_CONFIG__?: AiRuntimeConfig }).__MDT_CONFIG__ ?? {}) as AiRuntimeConfig) : {}

export const isAskMdtAvailable = (user: any, config: AiRuntimeConfig = runtimeAiConfig()): boolean => {
	if (!user || config.aiEnabled !== true) return false
	if (!getCapabilities(user).canUseAi) return false
	const accountType = user.accountType || 'pro'
	return !config.aiAccountTypes?.length || config.aiAccountTypes.includes(accountType)
}
